import { Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { float64_type, class_type, option_type, array_type, bool_type, int32_type, record_type, string_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { utcNow } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { PropulsionType_$reflection, Vessel_NavigationArea_$reflection, Vessel_FerryEuClass_$reflection, Vessel_Cert_$reflection, Vessel_Type_$reflection, Vessel_VesselState_$reflection } from "./Shared.js";
import { join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { map } from "../fable_modules/fable-library-js.4.24.0/Array.js";

export class GenericResponse extends Record {
    constructor(Result, Message) {
        super();
        this.Result = Result;
        this.Message = Message;
    }
}

export function GenericResponse_$reflection() {
    return record_type("ApiDataTypes.GenericResponse", [], GenericResponse, () => [["Result", string_type], ["Message", string_type]]);
}

export class Company extends Record {
    constructor(Id, Name, Enabled) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.Enabled = Enabled;
    }
}

export function Company_$reflection() {
    return record_type("ApiDataTypes.Company", [], Company, () => [["Id", int32_type], ["Name", string_type], ["Enabled", bool_type]]);
}

export class Role extends Record {
    constructor(RoleId, CompanyId, Company) {
        super();
        this.RoleId = (RoleId | 0);
        this.CompanyId = (CompanyId | 0);
        this.Company = Company;
    }
}

export function Role_$reflection() {
    return record_type("ApiDataTypes.Role", [], Role, () => [["RoleId", int32_type], ["CompanyId", int32_type], ["Company", string_type]]);
}

export class UserSession extends Record {
    constructor(Username, IsSuperAdmin, Companies, Roles, AppVersion) {
        super();
        this.Username = Username;
        this.IsSuperAdmin = IsSuperAdmin;
        this.Companies = Companies;
        this.Roles = Roles;
        this.AppVersion = AppVersion;
    }
}

export function UserSession_$reflection() {
    return record_type("ApiDataTypes.UserSession", [], UserSession, () => [["Username", string_type], ["IsSuperAdmin", bool_type], ["Companies", array_type(Company_$reflection())], ["Roles", array_type(Role_$reflection())], ["AppVersion", string_type]]);
}

export class LoginRequest extends Record {
    constructor(Email, Password) {
        super();
        this.Email = Email;
        this.Password = Password;
    }
}

export function LoginRequest_$reflection() {
    return record_type("ApiDataTypes.LoginRequest", [], LoginRequest, () => [["Email", string_type], ["Password", string_type]]);
}

export class LoginResponse extends Record {
    constructor(Result, Message, Session) {
        super();
        this.Result = Result;
        this.Message = Message;
        this.Session = Session;
    }
}

export function LoginResponse_$reflection() {
    return record_type("ApiDataTypes.LoginResponse", [], LoginResponse, () => [["Result", string_type], ["Message", string_type], ["Session", option_type(UserSession_$reflection())]]);
}

export class PaginatedResponse$1 extends Record {
    constructor(Entries, Page) {
        super();
        this.Entries = Entries;
        this.Page = (Page | 0);
    }
}

export function PaginatedResponse$1_$reflection(gen0) {
    return record_type("ApiDataTypes.PaginatedResponse`1", [gen0], PaginatedResponse$1, () => [["Entries", array_type(gen0)], ["Page", int32_type]]);
}

export class IdSeq extends Record {
    constructor(Type, Ids) {
        super();
        this.Type = Type;
        this.Ids = Ids;
    }
}

export function IdSeq_$reflection() {
    return record_type("ApiDataTypes.IdSeq", [], IdSeq, () => [["Type", string_type], ["Ids", array_type(int32_type)]]);
}

export class IdNameHelper extends Record {
    constructor(Id, Name) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
    }
}

export function IdNameHelper_$reflection() {
    return record_type("ApiDataTypes.IdNameHelper", [], IdNameHelper, () => [["Id", int32_type], ["Name", string_type]]);
}

export class SearchInput extends Record {
    constructor(Term) {
        super();
        this.Term = Term;
    }
}

export function SearchInput_$reflection() {
    return record_type("ApiDataTypes.SearchInput", [], SearchInput, () => [["Term", string_type]]);
}

export class Account extends Record {
    constructor(Id, Name, Email, Phone, IsSuperAdmin, Enabled, Companies, Roles) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Email = Email;
        this.Phone = Phone;
        this.IsSuperAdmin = IsSuperAdmin;
        this.Enabled = Enabled;
        this.Companies = Companies;
        this.Roles = Roles;
    }
}

export function Account_$reflection() {
    return record_type("ApiDataTypes.Account", [], Account, () => [["Id", class_type("System.Guid")], ["Name", string_type], ["Email", string_type], ["Phone", string_type], ["IsSuperAdmin", bool_type], ["Enabled", bool_type], ["Companies", array_type(Company_$reflection())], ["Roles", array_type(Role_$reflection())]]);
}

export class AccountMeta extends Record {
    constructor(Id, Name, Email) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Email = Email;
    }
}

export function AccountMeta_$reflection() {
    return record_type("ApiDataTypes.AccountMeta", [], AccountMeta, () => [["Id", class_type("System.Guid")], ["Name", string_type], ["Email", string_type]]);
}

export class AccountCompanyRequest extends Record {
    constructor(AccountId, CompanyId) {
        super();
        this.AccountId = AccountId;
        this.CompanyId = (CompanyId | 0);
    }
}

export function AccountCompanyRequest_$reflection() {
    return record_type("ApiDataTypes.AccountCompanyRequest", [], AccountCompanyRequest, () => [["AccountId", class_type("System.Guid")], ["CompanyId", int32_type]]);
}

export class AuditLog extends Record {
    constructor(EntityType, EntityId, Entity, EditDate, ChangesText, Editor) {
        super();
        this.EntityType = (EntityType | 0);
        this.EntityId = (EntityId | 0);
        this.Entity = Entity;
        this.EditDate = EditDate;
        this.ChangesText = ChangesText;
        this.Editor = Editor;
    }
}

export function AuditLog_$reflection() {
    return record_type("ApiDataTypes.AuditLog", [], AuditLog, () => [["EntityType", int32_type], ["EntityId", int32_type], ["Entity", string_type], ["EditDate", string_type], ["ChangesText", string_type], ["Editor", option_type(Account_$reflection())]]);
}

export class EventLog extends Record {
    constructor(Id, Text$, ResponseText, RegistrationDate, Author, DueDate, IsDone) {
        super();
        this.Id = (Id | 0);
        this.Text = Text$;
        this.ResponseText = ResponseText;
        this.RegistrationDate = RegistrationDate;
        this.Author = Author;
        this.DueDate = DueDate;
        this.IsDone = IsDone;
    }
}

export function EventLog_$reflection() {
    return record_type("ApiDataTypes.EventLog", [], EventLog, () => [["Id", int32_type], ["Text", string_type], ["ResponseText", string_type], ["RegistrationDate", class_type("System.DateTime")], ["Author", option_type(Account_$reflection())], ["DueDate", option_type(class_type("System.DateTime"))], ["IsDone", bool_type]]);
}

export function EventLog_create() {
    return new EventLog(-1, "", "", utcNow(), undefined, undefined, false);
}

export class OldNavigationArea extends Record {
    constructor(Id, Name, Enabled) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.Enabled = Enabled;
    }
}

export function OldNavigationArea_$reflection() {
    return record_type("ApiDataTypes.OldNavigationArea", [], OldNavigationArea, () => [["Id", int32_type], ["Name", string_type], ["Enabled", bool_type]]);
}

export class MobBoatType extends Record {
    constructor(Id, Name, Enabled) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.Enabled = Enabled;
    }
}

export function MobBoatType_$reflection() {
    return record_type("ApiDataTypes.MobBoatType", [], MobBoatType, () => [["Id", int32_type], ["Name", string_type], ["Enabled", bool_type]]);
}

export class MesType extends Record {
    constructor(Id, Name, Enabled) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.Enabled = Enabled;
    }
}

export function MesType_$reflection() {
    return record_type("ApiDataTypes.MesType", [], MesType, () => [["Id", int32_type], ["Name", string_type], ["Enabled", bool_type]]);
}

export class AutomationSystem extends Record {
    constructor(Id, Name, Enabled) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.Enabled = Enabled;
    }
}

export function AutomationSystem_$reflection() {
    return record_type("ApiDataTypes.AutomationSystem", [], AutomationSystem, () => [["Id", int32_type], ["Name", string_type], ["Enabled", bool_type]]);
}

export class Department extends Record {
    constructor(Id, Name, Enabled) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.Enabled = Enabled;
    }
}

export function Department_$reflection() {
    return record_type("ApiDataTypes.Department", [], Department, () => [["Id", int32_type], ["Name", string_type], ["Enabled", bool_type]]);
}

export class VesselCrewPosition extends Record {
    constructor(Id, Name, Enabled) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.Enabled = Enabled;
    }
}

export function VesselCrewPosition_$reflection() {
    return record_type("ApiDataTypes.VesselCrewPosition", [], VesselCrewPosition, () => [["Id", int32_type], ["Name", string_type], ["Enabled", bool_type]]);
}

export class VesselCrewMember extends Record {
    constructor(Id, VesselId, Account, Position) {
        super();
        this.Id = (Id | 0);
        this.VesselId = (VesselId | 0);
        this.Account = Account;
        this.Position = Position;
    }
}

export function VesselCrewMember_$reflection() {
    return record_type("ApiDataTypes.VesselCrewMember", [], VesselCrewMember, () => [["Id", int32_type], ["VesselId", int32_type], ["Account", Account_$reflection()], ["Position", VesselCrewPosition_$reflection()]]);
}

export class ElectricalPanelType extends Record {
    constructor(Id, Name, Enabled) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.Enabled = Enabled;
    }
}

export function ElectricalPanelType_$reflection() {
    return record_type("ApiDataTypes.ElectricalPanelType", [], ElectricalPanelType, () => [["Id", int32_type], ["Name", string_type], ["Enabled", bool_type]]);
}

export class VesselRoute extends Record {
    constructor(VesselId, Vessel, VesselImageId, RouteId, Route, RouteNumber, VesselRouteType) {
        super();
        this.VesselId = (VesselId | 0);
        this.Vessel = Vessel;
        this.VesselImageId = VesselImageId;
        this.RouteId = (RouteId | 0);
        this.Route = Route;
        this.RouteNumber = RouteNumber;
        this.VesselRouteType = (VesselRouteType | 0);
    }
}

export function VesselRoute_$reflection() {
    return record_type("ApiDataTypes.VesselRoute", [], VesselRoute, () => [["VesselId", int32_type], ["Vessel", string_type], ["VesselImageId", option_type(int32_type)], ["RouteId", int32_type], ["Route", string_type], ["RouteNumber", string_type], ["VesselRouteType", int32_type]]);
}

export class VesselRouteForm extends Record {
    constructor(VesselId, RouteId, VesselRouteType) {
        super();
        this.VesselId = (VesselId | 0);
        this.RouteId = (RouteId | 0);
        this.VesselRouteType = (VesselRouteType | 0);
    }
}

export function VesselRouteForm_$reflection() {
    return record_type("ApiDataTypes.VesselRouteForm", [], VesselRouteForm, () => [["VesselId", int32_type], ["RouteId", int32_type], ["VesselRouteType", int32_type]]);
}

export class CrewCertificate extends Record {
    constructor(Id, Name, Tier, Enabled) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.Tier = (Tier | 0);
        this.Enabled = Enabled;
    }
}

export function CrewCertificate_$reflection() {
    return record_type("ApiDataTypes.CrewCertificate", [], CrewCertificate, () => [["Id", int32_type], ["Name", string_type], ["Tier", int32_type], ["Enabled", bool_type]]);
}

export class VesselSimple extends Record {
    constructor(Id, Name, RouteType) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.RouteType = (RouteType | 0);
    }
}

export function VesselSimple_$reflection() {
    return record_type("ApiDataTypes.VesselSimple", [], VesselSimple, () => [["Id", int32_type], ["Name", string_type], ["RouteType", int32_type]]);
}

export class Route extends Record {
    constructor(Id, CompanyId, Type, Name, Number$, Status, Enabled, ActivityType, Address, PostalCode, PostalArea, Vessels) {
        super();
        this.Id = (Id | 0);
        this.CompanyId = (CompanyId | 0);
        this.Type = (Type | 0);
        this.Name = Name;
        this.Number = Number$;
        this.Status = (Status | 0);
        this.Enabled = Enabled;
        this.ActivityType = (ActivityType | 0);
        this.Address = Address;
        this.PostalCode = PostalCode;
        this.PostalArea = PostalArea;
        this.Vessels = Vessels;
    }
}

export function Route_$reflection() {
    return record_type("ApiDataTypes.Route", [], Route, () => [["Id", int32_type], ["CompanyId", int32_type], ["Type", int32_type], ["Name", string_type], ["Number", string_type], ["Status", int32_type], ["Enabled", bool_type], ["ActivityType", int32_type], ["Address", string_type], ["PostalCode", string_type], ["PostalArea", string_type], ["Vessels", array_type(VesselSimple_$reflection())]]);
}

export class Dependency extends Record {
    constructor(Name) {
        super();
        this.Name = Name;
    }
}

export function Dependency_$reflection() {
    return record_type("ApiDataTypes.Dependency", [], Dependency, () => [["Name", string_type]]);
}

export class RouteModule_RouteType extends Record {
    constructor(Id, Name, SortOrder, Enabled) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.SortOrder = (SortOrder | 0);
        this.Enabled = Enabled;
    }
}

export function RouteModule_RouteType_$reflection() {
    return record_type("ApiDataTypes.RouteModule.RouteType", [], RouteModule_RouteType, () => [["Id", int32_type], ["Name", string_type], ["SortOrder", int32_type], ["Enabled", bool_type]]);
}

export class RouteModule_RouteWithVessels extends Record {
    constructor(RouteId, Route, RouteNumber, Vessels) {
        super();
        this.RouteId = (RouteId | 0);
        this.Route = Route;
        this.RouteNumber = RouteNumber;
        this.Vessels = Vessels;
    }
}

export function RouteModule_RouteWithVessels_$reflection() {
    return record_type("ApiDataTypes.RouteModule.RouteWithVessels", [], RouteModule_RouteWithVessels, () => [["RouteId", int32_type], ["Route", string_type], ["RouteNumber", string_type], ["Vessels", array_type(VesselRoute_$reflection())]]);
}

export class RouteModule_RouteSummary extends Record {
    constructor(Id, Name, IsFavorite) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.IsFavorite = IsFavorite;
    }
}

export function RouteModule_RouteSummary_$reflection() {
    return record_type("ApiDataTypes.RouteModule.RouteSummary", [], RouteModule_RouteSummary, () => [["Id", int32_type], ["Name", string_type], ["IsFavorite", bool_type]]);
}

export class RouteModule_RouteInfo extends Record {
    constructor(Id, LegacyId, CompanyId, ClientId, Type, Name, Number$, PublicNumber, Status, Department, PostalAddress, PostalNumber, PostalCity, DeliveryBunkers, Dormitory, ProductionDemand, ActivityType, TenderStart, TenderEnd, TravelMethod, TravelMethodUrl, FreeText, IsFavorite) {
        super();
        this.Id = (Id | 0);
        this.LegacyId = LegacyId;
        this.CompanyId = (CompanyId | 0);
        this.ClientId = ClientId;
        this.Type = Type;
        this.Name = Name;
        this.Number = Number$;
        this.PublicNumber = PublicNumber;
        this.Status = (Status | 0);
        this.Department = Department;
        this.PostalAddress = PostalAddress;
        this.PostalNumber = PostalNumber;
        this.PostalCity = PostalCity;
        this.DeliveryBunkers = DeliveryBunkers;
        this.Dormitory = Dormitory;
        this.ProductionDemand = (ProductionDemand | 0);
        this.ActivityType = (ActivityType | 0);
        this.TenderStart = TenderStart;
        this.TenderEnd = TenderEnd;
        this.TravelMethod = TravelMethod;
        this.TravelMethodUrl = TravelMethodUrl;
        this.FreeText = FreeText;
        this.IsFavorite = IsFavorite;
    }
}

export function RouteModule_RouteInfo_$reflection() {
    return record_type("ApiDataTypes.RouteModule.RouteInfo", [], RouteModule_RouteInfo, () => [["Id", int32_type], ["LegacyId", option_type(int32_type)], ["CompanyId", int32_type], ["ClientId", string_type], ["Type", RouteModule_RouteType_$reflection()], ["Name", string_type], ["Number", string_type], ["PublicNumber", string_type], ["Status", int32_type], ["Department", option_type(Department_$reflection())], ["PostalAddress", string_type], ["PostalNumber", string_type], ["PostalCity", string_type], ["DeliveryBunkers", string_type], ["Dormitory", string_type], ["ProductionDemand", int32_type], ["ActivityType", int32_type], ["TenderStart", option_type(string_type)], ["TenderEnd", option_type(string_type)], ["TravelMethod", string_type], ["TravelMethodUrl", string_type], ["FreeText", string_type], ["IsFavorite", bool_type]]);
}

export class Vessel extends Record {
    constructor(Id, Uuid, CompanyId, IMONumber, Name, CallSign, Routes, Status, MainImageId, IsFavorite) {
        super();
        this.Id = (Id | 0);
        this.Uuid = Uuid;
        this.CompanyId = (CompanyId | 0);
        this.IMONumber = IMONumber;
        this.Name = Name;
        this.CallSign = CallSign;
        this.Routes = Routes;
        this.Status = Status;
        this.MainImageId = MainImageId;
        this.IsFavorite = IsFavorite;
    }
}

export function Vessel_$reflection() {
    return record_type("ApiDataTypes.Vessel", [], Vessel, () => [["Id", int32_type], ["Uuid", option_type(class_type("System.Guid"))], ["CompanyId", int32_type], ["IMONumber", option_type(int32_type)], ["Name", string_type], ["CallSign", string_type], ["Routes", array_type(VesselRoute_$reflection())], ["Status", Vessel_VesselState_$reflection()], ["MainImageId", option_type(int32_type)], ["IsFavorite", bool_type]]);
}

export class VesselModule_Type extends Record {
    constructor(Id, Type, Name, Enabled) {
        super();
        this.Id = (Id | 0);
        this.Type = (Type | 0);
        this.Name = Name;
        this.Enabled = Enabled;
    }
}

export function VesselModule_Type_$reflection() {
    return record_type("ApiDataTypes.VesselModule.Type", [], VesselModule_Type, () => [["Id", int32_type], ["Type", int32_type], ["Name", string_type], ["Enabled", bool_type]]);
}

export class VesselModule_VesselWithRoutes extends Record {
    constructor(VesselId, Vessel, Routes) {
        super();
        this.VesselId = (VesselId | 0);
        this.Vessel = Vessel;
        this.Routes = Routes;
    }
}

export function VesselModule_VesselWithRoutes_$reflection() {
    return record_type("ApiDataTypes.VesselModule.VesselWithRoutes", [], VesselModule_VesselWithRoutes, () => [["VesselId", int32_type], ["Vessel", string_type], ["Routes", array_type(VesselRoute_$reflection())]]);
}

export class VesselModule_VesselSummary extends Record {
    constructor(Id, Name, IsFavorite) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.IsFavorite = IsFavorite;
    }
}

export function VesselModule_VesselSummary_$reflection() {
    return record_type("ApiDataTypes.VesselModule.VesselSummary", [], VesselModule_VesselSummary, () => [["Id", int32_type], ["Name", string_type], ["IsFavorite", bool_type]]);
}

export class VesselModule_VesselImageForm extends Record {
    constructor(ImageId, ImageText, VesselId, Filename, Content) {
        super();
        this.ImageId = (ImageId | 0);
        this.ImageText = ImageText;
        this.VesselId = (VesselId | 0);
        this.Filename = Filename;
        this.Content = Content;
    }
}

export function VesselModule_VesselImageForm_$reflection() {
    return record_type("ApiDataTypes.VesselModule.VesselImageForm", [], VesselModule_VesselImageForm, () => [["ImageId", int32_type], ["ImageText", string_type], ["VesselId", int32_type], ["Filename", string_type], ["Content", string_type]]);
}

export class VesselModule_TimelineVessel extends Record {
    constructor(Id, Name, CompanyId, Favorite, Status) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.CompanyId = (CompanyId | 0);
        this.Favorite = Favorite;
        this.Status = (Status | 0);
    }
}

export function VesselModule_TimelineVessel_$reflection() {
    return record_type("ApiDataTypes.VesselModule.TimelineVessel", [], VesselModule_TimelineVessel, () => [["Id", int32_type], ["Name", string_type], ["CompanyId", int32_type], ["Favorite", bool_type], ["Status", int32_type]]);
}

export class VesselModule_VesselImageMeta extends Record {
    constructor(ImageId, VesselId, ImageText, Filename, Uploaded, UploadedByAccount, IsMain) {
        super();
        this.ImageId = (ImageId | 0);
        this.VesselId = (VesselId | 0);
        this.ImageText = ImageText;
        this.Filename = Filename;
        this.Uploaded = Uploaded;
        this.UploadedByAccount = UploadedByAccount;
        this.IsMain = IsMain;
    }
}

export function VesselModule_VesselImageMeta_$reflection() {
    return record_type("ApiDataTypes.VesselModule.VesselImageMeta", [], VesselModule_VesselImageMeta, () => [["ImageId", int32_type], ["VesselId", int32_type], ["ImageText", string_type], ["Filename", string_type], ["Uploaded", class_type("System.DateTime")], ["UploadedByAccount", option_type(class_type("System.Guid"))], ["IsMain", bool_type]]);
}

export class VesselModule_VesselImageSet extends Record {
    constructor(VesselId, MainImageId, Images) {
        super();
        this.VesselId = (VesselId | 0);
        this.MainImageId = MainImageId;
        this.Images = Images;
    }
}

export function VesselModule_VesselImageSet_$reflection() {
    return record_type("ApiDataTypes.VesselModule.VesselImageSet", [], VesselModule_VesselImageSet, () => [["VesselId", int32_type], ["MainImageId", option_type(int32_type)], ["Images", array_type(VesselModule_VesselImageMeta_$reflection())]]);
}

export class VesselModule_VesselDetails extends Record {
    constructor(Id, LegacyId, Uuid, InternalId, CompanyId, IMONumber, MMSINumber, Name, CallSign, Status, Type, SubType, Certificate, FerryEuClass, VesselType, VesselSubtype, Department, KeelStretchDate, HomePort, GrossTons, NetTons, SecurityTons, DeadWeightTons, LengthOverall, WidthOverall, WaterlineToRecess, WaterlineMaxHeight, WaterlineMaxDraft, NoXFactorMGO, NoXFactorLNG, OldNavigationArea, NavigationArea, SuspendedDeck, LowerDeck, CruisingSpeed, MaximumSpeed, MaximumDeckLoad, MaximumAxleLoad, ConstructionDate, PropulsionEffect, MaxClearanceHeight, TechnicalInspector, CrewCoordinator, PrimaryPropulsionType, SecondaryPropulsionType, PrimaryPropulsionEffect, SecondaryPropulsionEffect, AmpLandPower, VoltLandPower, LandPowerConnector, BatteryAge, BatteryType, BatteryEffect, BatteryProvider, BatteryChargingSystem, ElectricalPanelType, ElectricalPanelProvider, EngineProvider, MesType, MesCapacityPerFleet, MesCapacityTotal, MobBoatType, AutomationSystem, PhoneOne, PhoneTwo, PhoneCatering, PhoneSecret, PhoneMachine, Email, NumPassengers, NumPassengerSeats, EuroPallets, PBE, PBEOfVTE, VTE, MVTE, Cafeteria, SelfServiceMachine, SaloonOverWaterline, NumCompartments, HandicapToilet, Elevator, StairElevator, Wifi, Playroom, SickBay, RequireECDIS, RequireGMDSS, RequireHMOB, NumMachineFitters, NumMotorFitters, NumSailors, NumLightSailors, NumCateringStaff, CrewCertificateUrl, MesTraining, BatteryTraining, IgfCertificate, CaptainCertificate, ChiefMateCertificate, FirstMateCertificate, ChiefEngineerCertificate, FirstEngineerCertificate, SecondEngineerCertificate, FreeText, IsFavorite) {
        super();
        this.Id = (Id | 0);
        this.LegacyId = LegacyId;
        this.Uuid = Uuid;
        this.InternalId = InternalId;
        this.CompanyId = (CompanyId | 0);
        this.IMONumber = IMONumber;
        this.MMSINumber = MMSINumber;
        this.Name = Name;
        this.CallSign = CallSign;
        this.Status = Status;
        this.Type = Type;
        this.SubType = SubType;
        this.Certificate = Certificate;
        this.FerryEuClass = FerryEuClass;
        this.VesselType = VesselType;
        this.VesselSubtype = VesselSubtype;
        this.Department = Department;
        this.KeelStretchDate = KeelStretchDate;
        this.HomePort = HomePort;
        this.GrossTons = (GrossTons | 0);
        this.NetTons = (NetTons | 0);
        this.SecurityTons = SecurityTons;
        this.DeadWeightTons = (DeadWeightTons | 0);
        this.LengthOverall = LengthOverall;
        this.WidthOverall = WidthOverall;
        this.WaterlineToRecess = WaterlineToRecess;
        this.WaterlineMaxHeight = WaterlineMaxHeight;
        this.WaterlineMaxDraft = WaterlineMaxDraft;
        this.NoXFactorMGO = NoXFactorMGO;
        this.NoXFactorLNG = NoXFactorLNG;
        this.OldNavigationArea = OldNavigationArea;
        this.NavigationArea = NavigationArea;
        this.SuspendedDeck = SuspendedDeck;
        this.LowerDeck = LowerDeck;
        this.CruisingSpeed = (CruisingSpeed | 0);
        this.MaximumSpeed = (MaximumSpeed | 0);
        this.MaximumDeckLoad = MaximumDeckLoad;
        this.MaximumAxleLoad = MaximumAxleLoad;
        this.ConstructionDate = ConstructionDate;
        this.PropulsionEffect = (PropulsionEffect | 0);
        this.MaxClearanceHeight = MaxClearanceHeight;
        this.TechnicalInspector = TechnicalInspector;
        this.CrewCoordinator = CrewCoordinator;
        this.PrimaryPropulsionType = PrimaryPropulsionType;
        this.SecondaryPropulsionType = SecondaryPropulsionType;
        this.PrimaryPropulsionEffect = PrimaryPropulsionEffect;
        this.SecondaryPropulsionEffect = SecondaryPropulsionEffect;
        this.AmpLandPower = AmpLandPower;
        this.VoltLandPower = VoltLandPower;
        this.LandPowerConnector = LandPowerConnector;
        this.BatteryAge = BatteryAge;
        this.BatteryType = BatteryType;
        this.BatteryEffect = (BatteryEffect | 0);
        this.BatteryProvider = BatteryProvider;
        this.BatteryChargingSystem = BatteryChargingSystem;
        this.ElectricalPanelType = ElectricalPanelType;
        this.ElectricalPanelProvider = ElectricalPanelProvider;
        this.EngineProvider = EngineProvider;
        this.MesType = MesType;
        this.MesCapacityPerFleet = MesCapacityPerFleet;
        this.MesCapacityTotal = MesCapacityTotal;
        this.MobBoatType = MobBoatType;
        this.AutomationSystem = AutomationSystem;
        this.PhoneOne = PhoneOne;
        this.PhoneTwo = PhoneTwo;
        this.PhoneCatering = PhoneCatering;
        this.PhoneSecret = PhoneSecret;
        this.PhoneMachine = PhoneMachine;
        this.Email = Email;
        this.NumPassengers = (NumPassengers | 0);
        this.NumPassengerSeats = (NumPassengerSeats | 0);
        this.EuroPallets = EuroPallets;
        this.PBE = PBE;
        this.PBEOfVTE = PBEOfVTE;
        this.VTE = VTE;
        this.MVTE = MVTE;
        this.Cafeteria = Cafeteria;
        this.SelfServiceMachine = SelfServiceMachine;
        this.SaloonOverWaterline = SaloonOverWaterline;
        this.NumCompartments = NumCompartments;
        this.HandicapToilet = HandicapToilet;
        this.Elevator = Elevator;
        this.StairElevator = StairElevator;
        this.Wifi = Wifi;
        this.Playroom = Playroom;
        this.SickBay = SickBay;
        this.RequireECDIS = RequireECDIS;
        this.RequireGMDSS = RequireGMDSS;
        this.RequireHMOB = RequireHMOB;
        this.NumMachineFitters = NumMachineFitters;
        this.NumMotorFitters = NumMotorFitters;
        this.NumSailors = NumSailors;
        this.NumLightSailors = NumLightSailors;
        this.NumCateringStaff = NumCateringStaff;
        this.CrewCertificateUrl = CrewCertificateUrl;
        this.MesTraining = MesTraining;
        this.BatteryTraining = BatteryTraining;
        this.IgfCertificate = IgfCertificate;
        this.CaptainCertificate = CaptainCertificate;
        this.ChiefMateCertificate = ChiefMateCertificate;
        this.FirstMateCertificate = FirstMateCertificate;
        this.ChiefEngineerCertificate = ChiefEngineerCertificate;
        this.FirstEngineerCertificate = FirstEngineerCertificate;
        this.SecondEngineerCertificate = SecondEngineerCertificate;
        this.FreeText = FreeText;
        this.IsFavorite = IsFavorite;
    }
}

export function VesselModule_VesselDetails_$reflection() {
    return record_type("ApiDataTypes.VesselModule.VesselDetails", [], VesselModule_VesselDetails, () => [["Id", int32_type], ["LegacyId", option_type(int32_type)], ["Uuid", option_type(class_type("System.Guid"))], ["InternalId", option_type(int32_type)], ["CompanyId", int32_type], ["IMONumber", option_type(int32_type)], ["MMSINumber", option_type(int32_type)], ["Name", string_type], ["CallSign", string_type], ["Status", Vessel_VesselState_$reflection()], ["Type", option_type(Vessel_Type_$reflection())], ["SubType", option_type(Vessel_Type_$reflection())], ["Certificate", option_type(Vessel_Cert_$reflection())], ["FerryEuClass", option_type(Vessel_FerryEuClass_$reflection())], ["VesselType", option_type(VesselModule_Type_$reflection())], ["VesselSubtype", option_type(VesselModule_Type_$reflection())], ["Department", option_type(Department_$reflection())], ["KeelStretchDate", option_type(string_type)], ["HomePort", string_type], ["GrossTons", int32_type], ["NetTons", int32_type], ["SecurityTons", float64_type], ["DeadWeightTons", int32_type], ["LengthOverall", float64_type], ["WidthOverall", float64_type], ["WaterlineToRecess", float64_type], ["WaterlineMaxHeight", float64_type], ["WaterlineMaxDraft", float64_type], ["NoXFactorMGO", float64_type], ["NoXFactorLNG", float64_type], ["OldNavigationArea", option_type(OldNavigationArea_$reflection())], ["NavigationArea", option_type(Vessel_NavigationArea_$reflection())], ["SuspendedDeck", option_type(bool_type)], ["LowerDeck", option_type(bool_type)], ["CruisingSpeed", int32_type], ["MaximumSpeed", int32_type], ["MaximumDeckLoad", float64_type], ["MaximumAxleLoad", float64_type], ["ConstructionDate", option_type(string_type)], ["PropulsionEffect", int32_type], ["MaxClearanceHeight", float64_type], ["TechnicalInspector", string_type], ["CrewCoordinator", string_type], ["PrimaryPropulsionType", PropulsionType_$reflection()], ["SecondaryPropulsionType", PropulsionType_$reflection()], ["PrimaryPropulsionEffect", option_type(int32_type)], ["SecondaryPropulsionEffect", option_type(int32_type)], ["AmpLandPower", float64_type], ["VoltLandPower", float64_type], ["LandPowerConnector", option_type(int32_type)], ["BatteryAge", option_type(string_type)], ["BatteryType", string_type], ["BatteryEffect", int32_type], ["BatteryProvider", string_type], ["BatteryChargingSystem", string_type], ["ElectricalPanelType", option_type(ElectricalPanelType_$reflection())], ["ElectricalPanelProvider", string_type], ["EngineProvider", string_type], ["MesType", MesType_$reflection()], ["MesCapacityPerFleet", option_type(int32_type)], ["MesCapacityTotal", option_type(int32_type)], ["MobBoatType", MobBoatType_$reflection()], ["AutomationSystem", option_type(AutomationSystem_$reflection())], ["PhoneOne", string_type], ["PhoneTwo", string_type], ["PhoneCatering", string_type], ["PhoneSecret", string_type], ["PhoneMachine", string_type], ["Email", string_type], ["NumPassengers", int32_type], ["NumPassengerSeats", int32_type], ["EuroPallets", option_type(int32_type)], ["PBE", option_type(int32_type)], ["PBEOfVTE", option_type(int32_type)], ["VTE", option_type(int32_type)], ["MVTE", option_type(int32_type)], ["Cafeteria", option_type(bool_type)], ["SelfServiceMachine", option_type(bool_type)], ["SaloonOverWaterline", option_type(bool_type)], ["NumCompartments", option_type(int32_type)], ["HandicapToilet", option_type(bool_type)], ["Elevator", option_type(bool_type)], ["StairElevator", option_type(bool_type)], ["Wifi", option_type(bool_type)], ["Playroom", option_type(bool_type)], ["SickBay", option_type(bool_type)], ["RequireECDIS", option_type(bool_type)], ["RequireGMDSS", option_type(bool_type)], ["RequireHMOB", option_type(bool_type)], ["NumMachineFitters", option_type(int32_type)], ["NumMotorFitters", option_type(int32_type)], ["NumSailors", option_type(int32_type)], ["NumLightSailors", option_type(int32_type)], ["NumCateringStaff", option_type(int32_type)], ["CrewCertificateUrl", string_type], ["MesTraining", option_type(bool_type)], ["BatteryTraining", option_type(bool_type)], ["IgfCertificate", option_type(bool_type)], ["CaptainCertificate", option_type(CrewCertificate_$reflection())], ["ChiefMateCertificate", option_type(CrewCertificate_$reflection())], ["FirstMateCertificate", option_type(CrewCertificate_$reflection())], ["ChiefEngineerCertificate", option_type(CrewCertificate_$reflection())], ["FirstEngineerCertificate", option_type(CrewCertificate_$reflection())], ["SecondEngineerCertificate", option_type(CrewCertificate_$reflection())], ["FreeText", string_type], ["IsFavorite", bool_type]]);
}

export class VesselModule_VesselFilter extends Record {
    constructor(Companies, Status, Routes, Page, Favorites) {
        super();
        this.Companies = Companies;
        this.Status = Status;
        this.Routes = Routes;
        this.Page = (Page | 0);
        this.Favorites = Favorites;
    }
}

export function VesselModule_VesselFilter_$reflection() {
    return record_type("ApiDataTypes.VesselModule.VesselFilter", [], VesselModule_VesselFilter, () => [["Companies", array_type(int32_type)], ["Status", array_type(int32_type)], ["Routes", array_type(int32_type)], ["Page", int32_type], ["Favorites", bool_type]]);
}

export function VesselModule_VesselFilter_Default_4F10E657(userCompanies) {
    return new VesselModule_VesselFilter(userCompanies, new Int32Array([]), new Int32Array([]), 0, false);
}

export function VesselModule_VesselFilter__ToHttpVars(this$) {
    return `?favorites=${this$.Favorites}${join("", map((c) => (`&company=${c}`), this$.Companies))}${join("", map((s) => (`&status=${s}`), this$.Status))}${join("", map((r) => (`&route=${r}`), this$.Routes))}`;
}

export class VesselModule_ParsedVesselCsv extends Record {
    constructor(InternalId, Company, IMONumber, MMSINumber, Name, CallSign, Status, VesselType, VesselSubtype, Department, KeelStretchDate, HomePort, GrossTons, NetTons, SecurityTons, DeadWeightTons, LengthOverall, WidthOverall, WaterlineMaxHeight, WaterlineMaxDraft, NoXFactorMGO, NoXFactorLNG, NavigationArea, SuspendedDeck, LowerDeck, CruisingSpeed, MaximumSpeed, MaximumDeckLoad, MaximumAxleLoad, ConstructionDate, PropulsionEffect, MaxClearanceHeight, BatteryAge, BatteryType, BatteryEffect, BatteryProvider, BatteryChargingSystem, ElectricalPanelType, ElectricalPanelProvider, EngineProvider, MesType, MobBoatType, AutomationSystem, NumPassengerSeats, PBE, PBEOfVTE, VTE, Cafeteria, SelfServiceMachine, NumCompartments, RequireECDIS, RequireGMDSS, RequireHMOB, RequireEmissions) {
        super();
        this.InternalId = InternalId;
        this.Company = Company;
        this.IMONumber = IMONumber;
        this.MMSINumber = MMSINumber;
        this.Name = Name;
        this.CallSign = CallSign;
        this.Status = Status;
        this.VesselType = VesselType;
        this.VesselSubtype = VesselSubtype;
        this.Department = Department;
        this.KeelStretchDate = KeelStretchDate;
        this.HomePort = HomePort;
        this.GrossTons = (GrossTons | 0);
        this.NetTons = (NetTons | 0);
        this.SecurityTons = (SecurityTons | 0);
        this.DeadWeightTons = (DeadWeightTons | 0);
        this.LengthOverall = LengthOverall;
        this.WidthOverall = WidthOverall;
        this.WaterlineMaxHeight = WaterlineMaxHeight;
        this.WaterlineMaxDraft = WaterlineMaxDraft;
        this.NoXFactorMGO = NoXFactorMGO;
        this.NoXFactorLNG = NoXFactorLNG;
        this.NavigationArea = NavigationArea;
        this.SuspendedDeck = SuspendedDeck;
        this.LowerDeck = LowerDeck;
        this.CruisingSpeed = (CruisingSpeed | 0);
        this.MaximumSpeed = (MaximumSpeed | 0);
        this.MaximumDeckLoad = MaximumDeckLoad;
        this.MaximumAxleLoad = MaximumAxleLoad;
        this.ConstructionDate = ConstructionDate;
        this.PropulsionEffect = (PropulsionEffect | 0);
        this.MaxClearanceHeight = MaxClearanceHeight;
        this.BatteryAge = BatteryAge;
        this.BatteryType = BatteryType;
        this.BatteryEffect = BatteryEffect;
        this.BatteryProvider = BatteryProvider;
        this.BatteryChargingSystem = BatteryChargingSystem;
        this.ElectricalPanelType = ElectricalPanelType;
        this.ElectricalPanelProvider = ElectricalPanelProvider;
        this.EngineProvider = EngineProvider;
        this.MesType = MesType;
        this.MobBoatType = MobBoatType;
        this.AutomationSystem = AutomationSystem;
        this.NumPassengerSeats = (NumPassengerSeats | 0);
        this.PBE = PBE;
        this.PBEOfVTE = PBEOfVTE;
        this.VTE = VTE;
        this.Cafeteria = Cafeteria;
        this.SelfServiceMachine = SelfServiceMachine;
        this.NumCompartments = (NumCompartments | 0);
        this.RequireECDIS = RequireECDIS;
        this.RequireGMDSS = RequireGMDSS;
        this.RequireHMOB = RequireHMOB;
        this.RequireEmissions = RequireEmissions;
    }
}

export function VesselModule_ParsedVesselCsv_$reflection() {
    return record_type("ApiDataTypes.VesselModule.ParsedVesselCsv", [], VesselModule_ParsedVesselCsv, () => [["InternalId", option_type(int32_type)], ["Company", Company_$reflection()], ["IMONumber", option_type(int32_type)], ["MMSINumber", option_type(int32_type)], ["Name", string_type], ["CallSign", string_type], ["Status", Vessel_VesselState_$reflection()], ["VesselType", VesselModule_Type_$reflection()], ["VesselSubtype", option_type(string_type)], ["Department", option_type(Department_$reflection())], ["KeelStretchDate", option_type(string_type)], ["HomePort", string_type], ["GrossTons", int32_type], ["NetTons", int32_type], ["SecurityTons", int32_type], ["DeadWeightTons", int32_type], ["LengthOverall", float64_type], ["WidthOverall", float64_type], ["WaterlineMaxHeight", float64_type], ["WaterlineMaxDraft", float64_type], ["NoXFactorMGO", float64_type], ["NoXFactorLNG", float64_type], ["NavigationArea", string_type], ["SuspendedDeck", bool_type], ["LowerDeck", bool_type], ["CruisingSpeed", int32_type], ["MaximumSpeed", int32_type], ["MaximumDeckLoad", float64_type], ["MaximumAxleLoad", float64_type], ["ConstructionDate", option_type(string_type)], ["PropulsionEffect", int32_type], ["MaxClearanceHeight", float64_type], ["BatteryAge", option_type(string_type)], ["BatteryType", string_type], ["BatteryEffect", option_type(int32_type)], ["BatteryProvider", string_type], ["BatteryChargingSystem", string_type], ["ElectricalPanelType", option_type(string_type)], ["ElectricalPanelProvider", string_type], ["EngineProvider", string_type], ["MesType", string_type], ["MobBoatType", option_type(string_type)], ["AutomationSystem", option_type(string_type)], ["NumPassengerSeats", int32_type], ["PBE", option_type(int32_type)], ["PBEOfVTE", option_type(int32_type)], ["VTE", option_type(int32_type)], ["Cafeteria", bool_type], ["SelfServiceMachine", bool_type], ["NumCompartments", int32_type], ["RequireECDIS", bool_type], ["RequireGMDSS", bool_type], ["RequireHMOB", bool_type], ["RequireEmissions", bool_type]]);
}

export class VesselModule_VesselCsvForm extends Record {
    constructor(Content, Delimiter) {
        super();
        this.Content = Content;
        this.Delimiter = Delimiter;
    }
}

export function VesselModule_VesselCsvForm_$reflection() {
    return record_type("ApiDataTypes.VesselModule.VesselCsvForm", [], VesselModule_VesselCsvForm, () => [["Content", string_type], ["Delimiter", string_type]]);
}

export class VesselModule_VesselCsvResponse extends Record {
    constructor(Provided, Accepted, Vessels, Failed, Warnings) {
        super();
        this.Provided = (Provided | 0);
        this.Accepted = (Accepted | 0);
        this.Vessels = Vessels;
        this.Failed = Failed;
        this.Warnings = Warnings;
    }
}

export function VesselModule_VesselCsvResponse_$reflection() {
    return record_type("ApiDataTypes.VesselModule.VesselCsvResponse", [], VesselModule_VesselCsvResponse, () => [["Provided", int32_type], ["Accepted", int32_type], ["Vessels", array_type(VesselModule_ParsedVesselCsv_$reflection())], ["Failed", array_type(string_type)], ["Warnings", array_type(string_type)]]);
}

export class Activity extends Record {
    constructor(Id, VesselId, RouteId, WholeDay, FromDate, ToDate, InfoText, Confirmed, VesselAvailable, ActivityType) {
        super();
        this.Id = (Id | 0);
        this.VesselId = (VesselId | 0);
        this.RouteId = (RouteId | 0);
        this.WholeDay = WholeDay;
        this.FromDate = FromDate;
        this.ToDate = ToDate;
        this.InfoText = InfoText;
        this.Confirmed = Confirmed;
        this.VesselAvailable = VesselAvailable;
        this.ActivityType = ActivityType;
    }
}

export function Activity_$reflection() {
    return record_type("ApiDataTypes.Activity", [], Activity, () => [["Id", int32_type], ["VesselId", int32_type], ["RouteId", int32_type], ["WholeDay", bool_type], ["FromDate", string_type], ["ToDate", option_type(string_type)], ["InfoText", string_type], ["Confirmed", bool_type], ["VesselAvailable", bool_type], ["ActivityType", option_type(int32_type)]]);
}

export class UsageStatistics_Summary extends Record {
    constructor(NumUsers, LastSeven, ThisWeek, PrevWeek, Period) {
        super();
        this.NumUsers = (NumUsers | 0);
        this.LastSeven = (LastSeven | 0);
        this.ThisWeek = (ThisWeek | 0);
        this.PrevWeek = (PrevWeek | 0);
        this.Period = (Period | 0);
    }
}

export function UsageStatistics_Summary_$reflection() {
    return record_type("ApiDataTypes.UsageStatistics.Summary", [], UsageStatistics_Summary, () => [["NumUsers", int32_type], ["LastSeven", int32_type], ["ThisWeek", int32_type], ["PrevWeek", int32_type], ["Period", int32_type]]);
}

export class UsageStatistics_WeekEntry extends Record {
    constructor(Week, Count) {
        super();
        this.Week = Week;
        this.Count = (Count | 0);
    }
}

export function UsageStatistics_WeekEntry_$reflection() {
    return record_type("ApiDataTypes.UsageStatistics.WeekEntry", [], UsageStatistics_WeekEntry, () => [["Week", string_type], ["Count", int32_type]]);
}

//# sourceMappingURL=ApiDataTypes.js.map
